var map = {
	"./Aggressive/skillsData.json": [
		8534,
		534
	],
	"./Conservative/skillsData.json": [
		3805,
		805
	],
	"./PulseCast/skillsData.json": [
		7298,
		298
	],
	"./Realistic/skillsData.json": [
		2540,
		540
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 7179;
module.exports = webpackAsyncContext;